import {
  __async
} from "./chunk-WNQUEZJF.mjs";

// src/providers/user-id/user-id-provider.ts
var storageKeys = {
  multiUserAuth: "yvas",
  singleUserAuth: "yva"
};
function userIdProvider() {
  return __async(this, null, function* () {
    var _a, _b;
    let userId = null;
    const multiUserAuth = window.localStorage.getItem(storageKeys.multiUserAuth);
    const singleUserAuth = window.localStorage.getItem(storageKeys.singleUserAuth);
    if (multiUserAuth) {
      try {
        const parsedStoredAuth = JSON.parse(multiUserAuth);
        if (typeof parsedStoredAuth.current === "number" && parsedStoredAuth.tokens.length > 0 && parsedStoredAuth.current <= parsedStoredAuth.tokens.length) {
          const currentAuth = parsedStoredAuth.tokens[parsedStoredAuth.current];
          if (currentAuth.id) {
            userId = currentAuth.id;
          } else if (currentAuth.token.id) {
            userId = currentAuth.token.id;
          }
        }
      } catch (error) {
        if ((_a = window.yvaDatastore) == null ? void 0 : _a.config.debug) {
          console.error("Error parsing user data to get the user id");
          console.dir(error, { depth: null });
        }
      }
    }
    if (!userId && singleUserAuth) {
      try {
        const parsedStoredAuth = JSON.parse(singleUserAuth);
        if (parsedStoredAuth.id) {
          userId = parsedStoredAuth.id;
        }
      } catch (error) {
        if ((_b = window.yvaDatastore) == null ? void 0 : _b.config.debug) {
          console.error("Error parsing user data to get the user id");
          console.dir(error, { depth: null });
        }
      }
    }
    return userId;
  });
}

export {
  userIdProvider
};
